import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client';
import { toast } from 'react-toastify';
import { GraphQLError } from 'graphql';
import { onError } from '@apollo/client/link/error';
import ApolloLinkTimeout from 'apollo-link-timeout';
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs';

import { errorHandler } from '@utils/errors';
import { getCookie } from '@utils/cookie';

const errorLink = onError(({ graphQLErrors, networkError }) => {
    if (graphQLErrors) {
        graphQLErrors.forEach((error) => {
            const { message, locations, path } = error;

            console.info(
                `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(
                    locations
                )}, Path: ${path}`
            );
            errorHandler(error as GraphQLError);
        });
    }

    if (networkError) {
        console.info(`[Network error]: ${networkError}`);
        if (networkError.message === 'Timeout exceeded') {
            toast.error('요청 시간이 지났습니다. 잠시후 다시 시도해주세요.');
        }
    }
});

const timeoutLink = new ApolloLinkTimeout(30000);

const uploadLink = createUploadLink({
    uri: process.env.REACT_APP_SERVER_URL,
    credentials: 'include',
    headers: {
        Authorization: getCookie('PDT') ? `Bearer ${getCookie('PDT')}` : '',
        'Apollo-Require-Preflight': 'true'
    }
}) as unknown as ApolloLink;

const link = ApolloLink.from([
    errorLink,
    timeoutLink,
    uploadLink as ApolloLink
]);

const client = new ApolloClient({
    link: link,
    connectToDevTools: true,
    defaultOptions: {
        watchQuery: {
            fetchPolicy: 'no-cache'
        }
    },
    cache: new InMemoryCache()
});

export default client;
